import { IDynamicQueryService } from "../../service/dynamicQuery/DynamicQueryService";

export default class GetDynamicQueriesInteractor {
  private dynamicQueryService: IDynamicQueryService;

  constructor(dynamicQueryService) {
    this.dynamicQueryService = dynamicQueryService;
  }

  async execute() {
    return this.dynamicQueryService.getDynamicQueries();
  }
}
